function withSessionStorage(operation) {
    try {
        return operation(window.sessionStorage);
    } catch (error) {
        return null;
    }
}

export default withSessionStorage;
